module.exports = __webpack_public_path__ + "static/media/cafe_nordoy_thumb.648e98c2.jpg";